{
  "browserNotSupported": {
    "title": "El módulo no se ha podido cargar",
    "text": "Para utilizar el navegador de piezas, cambie a un navegador actualizado."
  },
  "main": {
    "more": "Más accesorios",
    "findMore": "Puede encontrar accesorios para reequipar/convertir y actualizar su vehículo aquí en nuestra amplia gama. Los accesorios que ha seleccionado se enviarán a su socio {{brand}} junto con la solicitud del vehículo.",
    "topOffers": "MEJORES ofertas",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Productos",
    "noArticleFound": "0 Productos",
    "oemHint": "Seleccione ahora los accesorios a juego para su {{brand}}.",
    "noBrand": "Seleccione ahora los accesorios adecuados para su vehículo.",
    "outOfOrder": "Lamentablemente, no hay productos disponibles en este momento.<0/>Actualmente estamos actualizando nuestro catálogo.<0/>Vuelva a visitarnos más adelante.",
    "nextSlide": "Siguiente",
    "prevSlide": "Anterior"
  },
  "cart": {
    "add": "Producto agregado al vehículo",
    "fullPrice": "Precio del vehículo y accesorios",
    "priceWithoutCar": "Precio accesorios"
  },
  "navigation": {
    "zoom": "Ampliar",
    "toggleSearch": "Alternar búsqueda",
    "cart": "Carrito",
    "cartDelete": "Eliminar artículo del carrito",
    "vehicle": "Vehículo seleccionado",
    "maxBookmarksReached": "Se alcanza un máximo de 15 productos",
    "filter": {
      "toggleFilter": "Alternar filtro",
      "topProducts": "MEJORES ofertas",
      "reset": "Reiniciar filtro",
      "ready": "Terminado",
      "show": "Mostrar resultados"
    },
    "searching": {
      "submit": "Enviar",
      "close": "Cerca",
      "placeholder": "Encuentra accesorios a juego ...",
      "suggestions": "Sugerencias de búsqueda",
      "categories": "Categorías",
      "products": "Productos",
      "productCount": "{{count}} producto",
      "productCount_other": "{{count}} productos",
      "showAll": "Mostrar {{count}} resultado",
      "showAll_other": "Mostrar los {{count}} resultados",
      "expand": "Búsqueda ampliada",
      "show": "Mostrar resultados",
      "found": {
        "withCategory": "Resultados de la búsqueda de \"{{fuzzy}}\" en la categoría \"{{category}}\"",
        "withOutCategory": "Resultados de la búsqueda de \"{{fuzzy}}\" en todas las categorías"
      }
    },
    "share": "Comparte",
    "back": "Atras",
    "details": "Detalles",
    "add": "Agregar",
    "remove": "Eliminar",
    "close": "Cerca",
    "filtern": "Filtro",
    "closeFilter": "Cerrar filtro"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Saltar a la imagen {{number}}"
    },
    "articleNumber": "Número de artículo",
    "relatedArticle": "Este artículo también podría interesarle:",
    "brand": "Marca",
    "priceBox": {
      "withVatAndMounting": "IVA & montaje incluido",
      "withVat": "IVA incluido",
      "recommendedRetailPrice": "Precio de venta recomendado sin compromiso",
      "historicMinimalPurchasePrice": "Precio más bajo en los últimos 30 días",
      "priceDetails": "Detalles del precio",
      "priceDetailsHeadline": "Detalles del precio de este artículo",
      "priceToday": "Precio de este artículo hoy",
      "priceDetails30Days": "Precio más bajo en los 30 días anteriores al cambio de precio",
      "close": "Cerrar",
      "addItem": "Añadir artículo",
      "removeItem": "Eliminar artículo"
    },
    "infoBox": {
      "description": "Descripción",
      "vehicles": "Adecuado para los siguientes modelos",
      "empty": "No hay asignaciones especiales de vehículos para este producto.",
      "contacts": "Fabricante"
    },
    "contacts": {
      "manufacturer-contact": "Información de contacto del fabricante",
      "responsible-contact": "Persona responsable en la UE",
      "trademark": "Marca"
    }
  },
  "productList": {
    "oemHint": "Accesorios originales para tu {{brand}}"
  }
}
